import React, { useState, useEffect, useMemo } from 'react';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData, fetchPieChartData, fetchDonorChartData } from '../reduxactions/adminrsactions/DashboardActions';
import { RootState } from '../reducers';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
const AdminDashboard: React.FC = () => {

  //to get session storage values
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')

  const dispatch = useDispatch();

  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchData(uid) as any);
        await dispatch(fetchPieChartData() as any);
        await dispatch(fetchDonorChartData() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataAsync();
  }, [dispatch]);

  const data = useSelector((state: RootState) => state.addashboard.data);
  const piechartData = useSelector((state: RootState) => state.addashboard.pieChartData);
  const ManagerchartData = useSelector((state: RootState) => state.addashboard.donorChartData);
  const piechartOptions = useSelector((state: RootState) => state.addashboard.piechartOptions);
  const ManagerchartOptions = useSelector((state: RootState) => state.addashboard.donorChart);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/admindashboard.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  const summary = data?.[0];

  const stats = useMemo(
    () => [
      {
        label: 'Donors',
        value: summary?.donor,
        icon: 'pi pi-user',
        className: 'app-stat-card--rose'
      },
      {
        label: 'Fund Managers',
        value: summary?.fundman,
        icon: 'pi pi-users',
        className: 'app-stat-card--green'
      },
      {
        label: 'Organizations',
        value: summary?.org,
        icon: 'pi pi-sitemap',
        className: 'app-stat-card--blue'
      },
      {
        label: 'Needs',
        value: summary?.needs,
        icon: 'pi pi-shopping-bag',
        className: 'app-stat-card--orange'
      }
    ],
    [summary]
  );

  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            {/* <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1>Dashboard</h1>
                  </div>
                  <div className="col-3">
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
                </div>
              </div>
            </section> */}
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Dashboard</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <section className="content">
              <div className="grid">
                {stats.map((stat: any) => (
                  <div
                    className="col-12 md:col-6 lg:col-3"
                    key={stat.label}
                  >
                    <div className={`app-stat-card ${stat.className}`}>
                      <div className="app-stat-card__content">
                        <div>
                          <span className="app-stat-card__label">
                            {stat.label}
                          </span>

                          <div className="app-stat-card__value">
                            {stat.value}
                          </div>
                        </div>

                        <span className="app-stat-card__icon">
                          <i
                            className={stat.icon}
                            style={{ fontSize: '3.5rem' }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid">
                <section className="col-6">
                  {/* <div className="box box-danger">
                    <Panel header="Donations" toggleable>
                      <Chart type="pie" style={{ height: '450px' }} data={piechartData} options={piechartOptions} />
                    </Panel>
                  </div> */}
                  <div className="surface-card shadow-3 border-round-2xl p-3">

                    <Panel
                      header="Donations Overview"
                      toggleable
                      className="border-none"
                    >

                      <div
                        className="flex align-items-center justify-content-center"
                        style={{ minHeight: '450px' }}
                      >

                        <Chart
                          type="doughnut"
                          style={{
                            width: '100%',
                            maxWidth: '520px',
                            height: '420px'
                          }}
                          data={piechartData}
                          options={piechartOptions}
                        />

                      </div>

                    </Panel>

                  </div>
                </section>
                <section className="col-6">
                  {/* <div className="box box-danger">
                    <Panel header="Applications" toggleable>
                      <Chart type="bar" style={{ height: '450px' }} data={ManagerchartData} options={ManagerchartOptions} />
                    </Panel>
                  </div> */}
                  <div className="surface-card shadow-3 border-round-2xl p-3">

                    <Panel
                      header="Applications Overview"
                      toggleable
                      className="border-none"
                    >

                      <div
                        className="flex align-items-center justify-content-center"
                        style={{ minHeight: '450px' }}
                      >

                        <Chart
                          type="bar"
                          style={{
                            width: '100%',
                            height: '420px'
                          }}
                          data={ManagerchartData}
                          options={ManagerchartOptions}
                        />

                      </div>

                    </Panel>

                  </div>
                </section>
              </div>

            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AdminDashboard;



